"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeMapPlaceId = exports.encodeMapPlaceId = exports.isMapPlaceId = void 0;
const lodash_1 = require("lodash");
const MAP_PLACE_ID_PREFIX = 'id_';
const isMapPlaceId = (rawParam) => {
    if ((0, lodash_1.isUndefined)(rawParam)) {
        return false;
    }
    return rawParam.startsWith(MAP_PLACE_ID_PREFIX);
};
exports.isMapPlaceId = isMapPlaceId;
const encodeMapPlaceId = (rawPlaceId) => `${MAP_PLACE_ID_PREFIX}${rawPlaceId}`;
exports.encodeMapPlaceId = encodeMapPlaceId;
const decodeMapPlaceId = (mapPlaceId) => mapPlaceId.replace(MAP_PLACE_ID_PREFIX, '');
exports.decodeMapPlaceId = decodeMapPlaceId;
//# sourceMappingURL=mapPlaceId.js.map